import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const CreateAccount = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/create-account/components/CreateAccountContent'
      )
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default CreateAccount;
